<template>
  <div class="content-wrapper">
    <loading v-model:active="isLoading" :is-full-page="true" />

    <h1>Registration</h1>

    <div class="registration-statement">
      <p>This registration process is optional.</p>
      <p>Registered users are able to save assessments to review again.</p>
      <p>Registering also contributes to our ongoing research projects, as well as efforts to improve access to
        endodontic care. User demographic data is used for these purposes. This data is stored anonymously and securely.
      </p>
      <p>If you agree to participate, please opt-in below and complete the registration process. Otherwise simply
        proceed to the 'Start Assessment' screen.</p>
      <hr v-if="registerAccount" />
    </div>

    <user-profile-form
      :is-registration="true"
      submit-button-text="Start Assessment"
      @validation-error="handleValidationError"
      @submit="handleRegistration"
    />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { useToast } from "vue-toastification";
import authStore from "../../store/auth-store";
import UserProfileForm from '../../components/UserProfileForm.vue';

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },

  components: {
    Loading,
    UserProfileForm
  },

  data() {
    return {
      isLoading: false,
      registerAccount: false,
      recaptchaSiteKey: '6LfhPPcqAAAAAKOWd8gempMAjNTPPsamSfVLzLpX',
      recaptchaToken: ''
    };
  },
  
  mounted() {
    this.registerAccount = false;
    if (this.user != null && !this.user.requiresDemographicData) {
      this.$router.push("/screening");
    }
  },

  computed: {
    user() {
      return authStore.state.user;
    }
  },

  methods: {
    handleValidationError(message) {
      this.toast.error(message);
    },

    async handleRegistration(formData) {
      try {
        // Generate recaptcha token
        const token = await window.grecaptcha.execute(this.recaptchaSiteKey, { action: 'assessment' });
        this.recaptchaToken = token;
      } catch (error) {
        this.toast.error("ReCAPTCHA verification failed. Please try again.");
        return;
      }

      this.isLoading = true;

      // Add recaptcha token to form data
      const dto = {
        name: formData.name,
        postcode: formData.postcode,
        acceptReferrals: formData.acceptReferrals,
        specialties: formData.selectedSpecialties || [],
        email: formData.email,
        password: formData.password,
        experience: formData.experience,
        undergraduateYear: formData.undergraduateYear === "" ? null : formData.undergraduateYear,
        graduationYear: formData.graduationYear === "" ? null : formData.graduationYear,
        countryOfQualification: formData.countryOfQualification,
        areaOfPractice: formData.areaOfPractice,
        havePostgraduateEndodontics: formData.havePostgraduateEndodontics === "" ? null : formData.havePostgraduateEndodontics === 'true',
        postgraduateEndodonticsExperience: formData.postgraduateEndodonticsExperience === "" ? null : formData.postgraduateEndodonticsExperience,
        postgraduateEndodonticsYear: formData.postgraduateEndodonticsYear === "" ? null : formData.postgraduateEndodonticsYear,
        recaptchaToken: this.recaptchaToken,
      };

      try {
        const response = await this.axios.post("/api/auth/register", dto);
        this.toast.success("Successfully saved demographic data");
        authStore.commit("setUser", response.data);
        this.$router.push("/");
      } catch (error) {
        this.toast.error(error.response?.data || "Registration failed");
        this.isLoading = false;
        return;
      }

      this.isLoading = false;
      this.$router.push("/screening");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../breakpoints.scss";

.content-wrapper {
  h1 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .registration-statement {
    margin-bottom: 10px;

    p {
      margin-bottom: 8px;
    }

    @include md {
      margin-bottom: 20px;
      margin-top: 20px;
    }
  }
}
</style>